import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { InvoiceUrl } from '../../../shared/urls/invoice.url'
import { Utility } from '../../../common/utility';

@Injectable()

export class CreditNoteService {
        constructor(public baseService: BaseService) { }

        saveCreditNote(creditNote: any, consultationId: any, invoiceId:any) {
                if (consultationId && invoiceId) {
                        const url = Utility.stringFormat(InvoiceUrl.ADD_INVOICE_CREDIT_NOTE, [invoiceId]);
                        return this.baseService.postData(url, creditNote);
                }
                const url = InvoiceUrl.ADD_CASH_SALE_CREDIT_NOTE;
                return this.baseService.postData(url, creditNote); 
        }
}


// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/cash-sale/credit-note-popup.service.ts